import EasyHTTP from "src/config/easyHttp";

export const SimpleHttp = new EasyHTTP();